import CreatorsDataTable from '../components/CreatorsDataTable';
import SEO from '../components/SEO';

export default function UKCreators() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="Top UK Travel Creators & Influencers | Waybook"
        description="Discover the best travel content creators and influencers from the United Kingdom. Get inspired by British travel experiences and destinations."
        keywords="UK travel creators, British travel influencers, United Kingdom travel bloggers, British travel content"
        canonicalUrl="https://www.waybook.me/recommended/uk"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'United Kingdom Travel Creators',
          description: 'Top travel content creators from the United Kingdom',
          url: 'https://www.waybook.me/recommended/uk'
        }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-4">🇬🇧 United Kingdom Travel Creators</h1>
        <p className="text-gray-600 mb-8">
          Discover the best travel content creators from the United Kingdom
        </p>
        <CreatorsDataTable 
          countryFilter="GB"
          showFilters={false}
          title="UK Creators"
          limit={20}
        />
      </div>
    </div>
  );
}
